export default "/images/image_3.jpg?12e4e04b6f5409753316a1f67925df09";